import { Component, Input, OnInit } from '@angular/core';

@Component({
  "selector": 'set-css',
  "template": '<!-- sets css -->',
})
export class SetCssComponent implements OnInit {
  @Input() theme: string = 'default';
  ngOnInit(): void {
    console.warn('switching to theme', this.theme);
    document.getElementById('css_flavor').setAttribute('href', 'assets/css/' + this.theme + '/styles.css');
  }
}
